import React from 'react'

import { Box } from 'app/components/design-system-components'
import 'app/sm/contact_list/header/style.scss'
import theme from 'app/match/applicationReportPDF/assets/theme'

const Header = () => {
  return (
    <div className="contact-list-header-container">
      <Box mb={theme.space[4] + 'px'}>
        <h1>Contacts</h1>
      </Box>
      <Box mb={7}>Add renter enquiries via Messages and owners via On List</Box>
    </div>
  )
}

export default Header
